export default "__VITE_ASSET__XLX$nnPt__"